import {BaseEntity} from './base-entity';
import {SharedDocument} from './shared-document';
import {MatterType} from './model/matter-type';
import {MatterInfo} from './matter-info';
import {ProvinceCode} from "../cirf/cirf";
import {DocumentsPackageHistoryRecord} from './shared-documents-package-history';

export type  ConnectRecipientRoleType = 'CLIENT' | 'OTHER_PARTY_LAW_CLERK' | 'VENDOR' | 'OTHER_PARTY_SOLICITOR' | 'MORTGAGE_SOLICITOR' | 'SOLICITOR' | 'INSURER' | 'BROKER' | 'CONDO_CORPORATION' |  'MORTGAGEE' | 'MORTGAGE_BROKER' |
    'REAL_ESTATE_AGENT' | 'REAL_ESTATE_BROKER' | 'OTHER_PARTY_REAL_ESTATE_AGENT' | 'OTHER_PARTY_REAL_ESTATE_BROKER';
export type PackageSharingStatus = 'AVAILABLE' | 'REVOKED' | 'PARTIALLY_REVOKED';

export class SharedDocumentsPackage extends  BaseEntity{
    documents: SharedDocument[] = [];
    guid: string;

    matterType: MatterType;
    lastUpdatedTimeStamp: number;
    matterId: number;
    matterAddressOrDescription: string;

    matterInfo: MatterInfo;
    provinceCode: ProvinceCode;

    connectRecipientRole: string;
    connectRecipientRoleType : ConnectRecipientRoleType;
    packageSharingStatus: PackageSharingStatus ;
    documentsPackageHistoryRecords: DocumentsPackageHistoryRecord[] = [];

    constructor(sharedDocumentsPackage? : SharedDocumentsPackage) {
        super(sharedDocumentsPackage);
        if(sharedDocumentsPackage){

            if(sharedDocumentsPackage.documents){
                this.documents = [];
                sharedDocumentsPackage.documents.forEach((document) => {
                    this.documents.push(new SharedDocument(document));
                });
            }
            if(sharedDocumentsPackage.matterInfo) {
                this.matterInfo = new MatterInfo(sharedDocumentsPackage.matterInfo);
            }
            if (sharedDocumentsPackage.documentsPackageHistoryRecords){
                this.documentsPackageHistoryRecords = [];
                sharedDocumentsPackage.documentsPackageHistoryRecords.forEach((historyRecord: DocumentsPackageHistoryRecord) => {
                    this.documentsPackageHistoryRecords.push(new DocumentsPackageHistoryRecord(historyRecord));
                });
            }
        }
    }

    isUserOtherPartyProjectLawyerOrLawClerk() : boolean {
        return (this.connectRecipientRoleType === 'OTHER_PARTY_LAW_CLERK' || this.connectRecipientRoleType === 'OTHER_PARTY_SOLICITOR'
            || this.connectRecipientRoleType  === 'SOLICITOR');
    }

    isSharingRevoked() : boolean {
        return this.packageSharingStatus == 'REVOKED';
    }

    isSharingPartiallyRevoked() : boolean {
        return this.packageSharingStatus == 'PARTIALLY_REVOKED';
    }

    isSharingAvailable() : boolean {
        return this.packageSharingStatus == 'AVAILABLE';
    }

    getDocumentsPackageHistoryRecordsForDocument(documentName: string): DocumentsPackageHistoryRecord[] {
        const result: DocumentsPackageHistoryRecord[] = this.documentsPackageHistoryRecords.filter( item => item.getHistorySharedDocumentByName(documentName));
        return result;
    }

}
